// @flow

import type {CardSummary} from './card-summary'

export type OrderTerminateCardRequest = {
  terminableCardIds: number[]
}

const buildOrderTerminateCardRequest = (cardSummaries: CardSummary[] = []): OrderTerminateCardRequest => {
  return {
    terminableCardIds: cardSummaries.map(cardSummary => cardSummary.cardId)
  }
}

export {
  buildOrderTerminateCardRequest
}



// WEBPACK FOOTER //
// ./src/types/order-terminate-card-request.js